import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-inspiration-card',
  templateUrl: './inspiration-card.component.html',
  styleUrls: ['./inspiration-card.component.css'],
})
export class InspirationCardComponent implements OnInit {

  @Input() image;
  @Input() hasContent = true;

  constructor() { }

  ngOnInit() {}

}
